module.exports = __webpack_public_path__ + "static/media/letter-outgoing.74a167e7.png";